import axios from "axios";

interface WidenResponse {
	result: Record<string, any> | false;
}

interface WidenService {
	getWidenData(widenId: string, vhost: string): Promise<Record<string, any>>;
}

const WidenService: WidenService = {
	async getWidenData(widenId: string, vhost: string): Promise<Record<string, any>> {
		const widenIDs = widenId.split(/,\s*/);
const widenCloneData: Record<string, any> = {};

for (const wId of widenIDs) {
	try {
		const response = await axios.post<WidenResponse>("/services/json", {
			method: "media.getWidenData",
			vhost,
			widenId: wId,
		});

		if (response.data.result !== false) {
			const data = Object.values(response.data.result)[0];
			widenCloneData[wId] = data;
		} else {
			console.warn(`No asset found for Widen ID: ${wId}`);
		}
	} catch (error) {
		console.error(`Error fetching data for Widen ID ${wId}:`, error);
		throw new Error(`Failed to fetch data for Widen ID: ${wId}`);
	}
}

return widenCloneData;
	},
};

export default WidenService;

